import React, { useState, useRef, useEffect } from 'react';

// SunEditor/index.js
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { useController } from 'react-hook-form';

const ButtonCustomList = [
	[ 'formatBlock' ],
	[ 'bold' ],
	[ 'list' ],
];
const CuttedButtonCustomList = [];

const TemplateCreateRTEditor = ({ 
	control, 
	name, 
	defaultValue, 
	required = false, 
	placeholder='',
	cutted = false,
	//...props,
}) => {
	const [ fieldInitialValue, setFieldInitialValue ] = useState('');
	// const [ sunInstance, setSunInstance ] = useState(null);
	// const {
	// 	field: {
	// 		value,
	// 		...inputProps
	// 	},
	// 	fieldState,
	// 	formState: {
	// 		touchedFields,
	// 		dirtyFields,
	// 	},
	// } = useController({
	// 	name,
	// 	control,
	// 	rules: { required: true },
	// 	defaultValue: defaultValue || '',
	// });

	const editorRef = useRef();

	const getSunEditorInstance = (instance) => {
		editorRef.current = instance;
	};

	const {
		// ref: myRef,
		field,
		// field: {
		// 	value,
		// 	onBlur,
		// 	onChange,
		// },
	} = useController({
		name,
		control,
		rules: { required: required },
		// rules: { required: true },
		defaultValue: defaultValue || '',
	});

	useEffect(() => {
		if (field.value && field.value.length > 0) {
			setTimeout(() => setFieldInitialValue(field.value), 10);
		}
	}, [ field ]);

	return (
		<SunEditor
			lang='pl'
			getSunEditorInstance={ getSunEditorInstance }
			// { ...props }
			name={ name }
			onChange={ field.onChange }
			onBlur={ field.onBlur }
			// defaultValue={ field.value }
			placeholder={ placeholder }
			setOptions={ {
				height: 200,
				buttonList: cutted ? CuttedButtonCustomList : ButtonCustomList,
				formats: [ 'h2', 'p' ],
			} }
			setContents={ fieldInitialValue }
			onPaste={ (event, cleanData) => {
				if (!cutted) return cleanData;

				// first replace all <p> tags with @@p$
				const pOpenRemovedString = cleanData.replace(/<p[^>]*>/g, "@@p$");

				// then - replace closing </p> tags with @@pc$
				const pCloseRemovedString = pOpenRemovedString.replace(/<\/p[^>]*>/g, "@@pc$");
                
				// then replace all <sup> tags with @@sup$
				const supOpenRemovedString = pCloseRemovedString.replace(/<sup[^>]*>/g, "@@sup$");

				// ... and all </sup> tags with @@supc$
				const supCloseRemovedString = supOpenRemovedString.replace(/<\/sup[^>]*>/g, "@@supc$");

				// now it's time to remove all remaining html tags
				const tagsRemovedString = supCloseRemovedString.replace(/(<([^>]+)>)/ig, "");

				// finally - recover p's and sup's
				const finalString = tagsRemovedString.replace(/@@p$/g, "<p>").replace(/@@pc$/g, "</p>").replace(/@@sup$/g, "<sup>").replace(/@@supc$/g, "</sup");
				return finalString;
			} }
		/>
	);
};

export default React.memo(TemplateCreateRTEditor);